import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { hideHeader, hideLogoAndFooter, changeBgColor } from "../../../actions/appStatus.actions";
import { callBeginCardControlsSession } from "../../../actions/cardControls.actions";
import { CardControlsErrorPage } from "../error-page/card-controls-error-page.component";

const CardControlsIntakeComponent = (props) => {
  const guid = props.match.params.guid || null;

  useEffect(() => {
    props.hideLogoAndFooter();
    props.hideHeader();
    props.changeBgColor("#fcfdfe");

    props.callBeginCardControlsSession(guid, props.history);
  }, []);

  if (props.authPayment.hasError) {
    return <CardControlsErrorPage />
  }

  return <div></div>;
};

// Map global store to component props
const mapStateToProps = (state) => state;

// Hook up actions to component
const mapDispatchToProps = {
  hideHeader,
  changeBgColor,
  hideLogoAndFooter,
  callBeginCardControlsSession,
};

//Connect to Redux store
const CardControlsIntake = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CardControlsIntakeComponent)
);

export default CardControlsIntake;



// WEBPACK FOOTER //
// ./src/components/card-controls/intake/card-controls-intake.component.js